import { useMemo } from 'react';
import { NumberFormatter } from './number-formatter';

const LOCALE = 'en-US';

export function useNumberFormatter(
  locale = LOCALE,
  options?: Intl.NumberFormatOptions,
) {
  const numberFormatter = useMemo(
    () => new NumberFormatter(locale, options),
    [locale, options],
  );

  return numberFormatter;
}
